<template>
  <div>
    <emd-admin-fields :emd-id="emdId" @success="transferData" ></emd-admin-fields>
  </div>
</template>

<script>
import EmdAdminFields from "./EmdAdminFields";
import ReportsIndex from "./ReportsIndex";

export default {
  name: "ReportFields",
  components: {ReportsIndex, EmdAdminFields},
  props: {
    emdId: {
      type: Number,
      default: 0
    },
    redirectUrl: ''
  },
  data() {
    return {
      reportData: [],
      showReport: false
    }
  },
  methods: {
    transferData() {
      window.location.href = this.redirectUrl
    }
  }
}
</script>